/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface WalletUpdateModel { 
    id: string;
    walletId?: string;
    creatorId?: string;
    referenceNumber?: string;
    amount: number;
    currencyType: number;
    userId?: string;
    userCategory?: string;
    userName?: string;
    creditorId?: string;
    creditorName?: string;
    walletBalance: number;
    transactionType?: string;
    description?: string;
    note?: string;
    dateUpdated: Date;
}
